import { render, staticRenderFns } from "./InputFormCompany.vue?vue&type=template&id=1be7ef11&scoped=true"
import script from "./InputFormCompany.vue?vue&type=script&lang=js"
export * from "./InputFormCompany.vue?vue&type=script&lang=js"
import style0 from "./InputFormCompany.vue?vue&type=style&index=0&id=1be7ef11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be7ef11",
  null
  
)

export default component.exports